import InvitingModal from "./invitingModal";

export default InvitingModal;
